export const PERMIT_ONE = "Crear";
export const PERMIT_TWO = "Editar";
export const PERMIT_TREE = "Eliminar";
export const PERMIT_FOUR = "Ver";
export const ROLSA = "SuperAdmin";
export const MODULE_FORBIDDEN = "Administración de modulos";
export const MENU_FORBIDDEN = "Modulos";
export const API_INFO = process.env.REACT_APP_API_INFO;
